import { useState } from 'react';
import { columns, mobileColumns } from './Column';
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable';
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize';
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable';
import ReportFooter from '../../ReportsFooter/ReportFooter';
import { useLocation } from 'react-router-dom';

const InitialReviewsByCongregationTable = ({
    isLoading,
    data,
    DisplayDate,
    handleColumnSort,
    downloadPDF,
    downloadExcel,
    tableOptions,
    pageCount,
    handlePageClick,
    handleRowsPerPage,
    totaldata,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
}) => {
    const [currentRow, setCurrentRow] = useState(null);
    const size = useWindowSize();
    const location = useLocation();

    const { pathname } = location;


    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-2">Initial Reviews By Congregation</h1>
                <h6 className="text-muted mb-1 fw-normal">
                    The grid below shows incidents tagged as CLOSED or AWAITING
                    WMRC between {DisplayDate?.startDate} and {DisplayDate?.endDate}.
                </h6>
                <p className='mb-4'>Total records is {totaldata} </p>
                <ReactExpandableTable
                    isLoading={isLoading}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    data={data}
                    mobileColumns={mobileColumns}
                    handleColumnSort={handleColumnSort}
                    removePagination={false}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    handleRowsPerPage={handleRowsPerPage}
                    handlePageClick={handlePageClick}
                    totaldata={totaldata}
                    pageCount={pageCount}
                />
                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    generatePDFFunction={generatePDFFunction}
                />
            </>
        );
    }

    return (
        <>
            {pathname === "/reports/InitialReviewsByCongregation" ? (
                <h1 className="mb-2">Initial Reviews By Congregation</h1>
            ) : (
                <h1 className="mb-2">Local Reviews By Congregation</h1>
            )}
            <h6 className="text-muted mb-1 fw-normal">
                The grid below shows incidents tagged as CLOSED or AWAITING WMRC
                between {DisplayDate?.startDate} and {DisplayDate?.endDate}.
            </h6>
            <p className='mb-4'>Total records is {totaldata} </p>
            <ReactDataTable
                isLoading={isLoading}
                data={data}
                columns={columns}
                removePagination={false}
                handleColumnSort={handleColumnSort}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                handleRowsPerPage={handleRowsPerPage}
                handlePageClick={handlePageClick}
                totaldata={totaldata}
                pageCount={pageCount}
            />
            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
            />
        </>
    );
};

export default InitialReviewsByCongregationTable;
